import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
// @mui
import { Collapse } from '@mui/material';
// hooks
import useActiveLink from '../../../hooks/useActiveLink';
//
import NavItem from './NavItem';

// ----------------------------------------------------------------------

NavList.propTypes = {
  data: PropTypes.object,
  depth: PropTypes.number,
  hasChild: PropTypes.bool,
  checkIsAllowed: PropTypes.func,
  theme: PropTypes.object
};

export default function NavList({ data, depth, hasChild, checkIsAllowed, theme }) {
  const { pathname } = useLocation();

  // `exactActive` items highlight only on their own route, not on nested child
  // routes (e.g. "Phiếu chi" must not light up while on "Phiếu chi/tao").
  const { active, isExternalLink } = useActiveLink(data.path, !data.exactActive);

  const [open, setOpen] = useState(active);

  useEffect(() => {
    if (!active) {
      handleClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const handleToggle = () => {
    setOpen(!open);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <NavItem
        item={data}
        depth={depth}
        open={open}
        active={active}
        isExternalLink={isExternalLink}
        theme={theme}
        onClick={handleToggle}
      />

      {hasChild && (
        <Collapse in={open} unmountOnExit>
          <NavSubList data={data.children} depth={depth} checkIsAllowed={checkIsAllowed} theme={theme} />
        </Collapse>
      )}
    </>
  );
}

// ----------------------------------------------------------------------

NavSubList.propTypes = {
  data: PropTypes.array,
  depth: PropTypes.number,
  checkIsAllowed: PropTypes.func
};

function NavSubList({ data, depth, checkIsAllowed, theme }) {
  return (
    <>
      {data.map(
        (list) => {
          let type = 'listMenu';
          let dataSub = list;
          if (list.children) {
            type = 'subheader2';
            dataSub = list.children;
          }
          return (
            checkIsAllowed(type, dataSub) &&
            <NavList key={list.title + list.path} data={list} depth={depth + 1} hasChild={!!list.children} theme={theme} />
          )
        }
      )}
    </>
  );
}
